// extracted by mini-css-extract-plugin
export default {"changeOperator":"ChangeOperator_changeOperator__0ILKA"};